<template>
  <span>
    <span
      v-for="(part, index) in parts"
      :key="`part-${index}`"
      :class="{ 'phrase-with-user-text__user-text': part.isUserText }"
    >{{ part.text }}</span>
  </span>
</template>

<script>
export default {
  name: 'PhraseWithUserText',
  props: {
    phrase: {
      type: String,
      required: true,
    },
    texts: {
      type: Array,
      required: true,
    },
  },
  computed: {
    parts() {
      const parts = [];
      const phraseParts = this.phrase.split(/%\w*%/g);
      for (let x = 0; x < phraseParts.length; x += 1) {
        parts.push({ text: phraseParts[x] });
        if (this.texts[x] != null) {
          parts.push({
            text: this.texts[x],
            isUserText: true,
          });
        }
      }
      return parts;
    },
  },
};
</script>

<style scoped>
  .phrase-with-user-text__user-text {
    font-style: italic;
    text-decoration: underline;
  }
</style>
